import styled from '@emotion/styled';

export const DayTravelHeader = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr 24px;
  grid-gap: 5px;
  align-items: center;
`;